import type { ScreenConnection } from "../displayConnection.ts";
import { motion } from "framer-motion";

/**
 * Two facts, one pixel budget: is this page connected to the relay, and is the
 * robot itself connected. Distinguishing them turns "the screen is stuck" into
 * an answerable question during a demo.
 */
export function StatusDot({ connected, robotOnline, connection, speaking = false }: { connected: boolean; robotOnline: boolean; connection: ScreenConnection; speaking?: boolean }) {
  const color = !connected ? "#f05a45" : robotOnline ? "#79e3cf" : "#edbd77";
  const label = connection === "access-required" ? "يلزم رابط الشاشة الخاص"
    : !connected ? "جارٍ الاتصال بالعرض"
    : robotOnline ? (speaking ? "رِفْق تتحدث" : "المحادثة متصلة") : "الشاشة متصلة · بانتظار بدء المحادثة";

  return (
    <div className="group fixed top-4 left-4 z-50 flex items-center gap-2" title={label} role="status" aria-live="polite">
      <motion.span
        className="h-2.5 w-2.5 rounded-full"
        style={{ background: color }}
        animate={{ opacity: connected && robotOnline ? [0.55, 1, 0.55] : 1 }}
        transition={{ duration: 2.2, repeat: Infinity }}
      />
      <span className="rounded-full bg-slate-950/85 px-3 py-1 text-[12px] text-white">
        {label}
      </span>
    </div>
  );
}
